// extracted by mini-css-extract-plugin
module.exports = {"videoIframe":"video-module--videoIframe--xYayg","videoContainer":"video-module--videoContainer--1-Ftg"};